import { useState } from "react";
import { tags } from "@/mocks/homeData";
import SectionHeading from "@/pages/home/components/SectionHeading";

const trendMap = {
  hot: { label: "热议", cls: "bg-primary-100 text-primary-700" },
  up: { label: "上升", cls: "bg-accent-100 text-accent-800" },
  new: { label: "新标签", cls: "bg-secondary-100 text-secondary-800" },
};

export default function TagsSection() {
  const [active, setActive] = useState("剪辑争议");
  const selected = tags.find((tag) => tag.name === active) ?? tags[0];

  return (
    <section id="tags" className="w-full border-t border-background-200 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="Tags · 标签聚合"
              title="一枚标签，串起跨圈层的话题"
              desc="标签把散落在不同圈子的同类讨论聚到一起，点选即可快速筛选，话题脉络一目了然。"
            />

            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="text-xs text-foreground-500">当前选中标签</p>
              <div className="mt-2 flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className="ri-price-tag-3-line"></i>
                </span>
                <span className="font-heading text-lg font-bold text-foreground-950">{selected.name}</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                已被 <span className="font-medium text-primary-600">{selected.count}</span>{" "}
                条话题引用，分布在影视、综艺、消费、电竞等多个圈子中。
              </p>
              <a
                href="#topics"
                className="mt-4 flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-filter-3-line"></i>
                </span>
                按标签筛选内容
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-wrap gap-2.5">
              {tags.map((tag) => {
                const isActive = tag.name === active;
                const trend = trendMap[tag.trend];
                return (
                  <button
                    key={tag.name}
                    type="button"
                    onClick={() => setActive(tag.name)}
                    className={`flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2.5 text-sm transition-colors ${
                      isActive
                        ? "border-primary-500 bg-primary-500 text-background-50"
                        : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                    }`}
                  >
                    <span
                      className={`rounded-sm px-1.5 py-0.5 text-[10px] font-medium ${
                        isActive ? "bg-background-50/20 text-background-50" : trend.cls
                      }`}
                    >
                      {trend.label}
                    </span>
                    {tag.name}
                    <span className={`text-xs ${isActive ? "text-background-50/70" : "text-foreground-400"}`}>
                      {tag.count}
                    </span>
                  </button>
                );
              })}
            </div>

            <p className="mt-6 flex items-center gap-2 text-xs text-foreground-500">
              <span className="flex h-4 w-4 items-center justify-center text-secondary-600">
                <i className="ri-lightbulb-line"></i>
              </span>
              标签可交叉组合，例如「剪辑争议 + 幕后花絮」，用来把跨圈层的话题收进同一条脉络。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}